















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import YoutubePopup from '@/components/Blocks/YoutubePlaylist/YoutubePopup.vue';

@Component({
    components: {
        YoutubePopup
    }
})
export default class YoutubePopupLink extends Vue {
    @Prop() protected link!: string | null;
    @Prop() protected title!: string | null;
    @Prop() protected linkClass!: string | null;

    public openModal(props: any) {
        this.$modal.show(
            YoutubePopup,
            props,
            {
                adaptive: true,
                height: 'auto',
                width: '90vw',
                maxWidth: 1200,
                scrollable: false
            }
        );
    }

    playVideo() {
        if (this.link !== null && this.link !== undefined && this.link !== '') {
            this.openModal({
                youtubeUrl: this.link,
                youtubeTitle: ''
            });
        }
    }
}
